import { useAuth, useProgram, useConfig, useDishsItems } from '~/hooks';
import { config } from '~/utils/config';

export type AccessLink = {
  key: string;
  label: string;
  icon: string; // clase d-icon del template
  href?: string;
  external?: boolean;
  onClick?: () => void;
};

// Hook compartido con las reglas de visibilidad de los accesos por programa.
// Centraliza la lógica para que el sub-nav (header-bottom) y el MobileMenu
// muestren exactamente lo mismo, sin duplicar condicionales. Devuelve solo los
// accesos visibles para el programa/participante actual.
export function useProgramAccess(): AccessLink[] {
  const { participant, accessToken } = useAuth();
  const { program } = useProgram();
  const { data } = useConfig();
  const { couldSeeResults } = useDishsItems();
  const canShowUploadInvoices =
    program?.id === 2
      ? Boolean(participant?.group?.canUploadSnaps)
      : Boolean(data?.permissions?.canUploadSnaps);

  const isSupervisor =
    program?.id === 33 &&
    participant?.position?.id?.toString() === config.program.supervisorPositionId;

  const links: (AccessLink & { show: boolean })[] = [
    {
      key: 'capacitaciones',
      label: 'Capacitaciones',
      icon: 'd-icon-student',
      show: Boolean(program?.hasAcademy) && program?.id !== 3,
      href: `${program?.academyUrl}?token=${accessToken}`,
      external: true,
    },
    {
      key: 'registrar-dependiente',
      label: 'Registrar Dependiente',
      icon: 'd-icon-user',
      show: isSupervisor,
      href: '/pages/create-participant',
    },
    {
      key: 'subir-facturas',
      label: 'Subir Facturas',
      icon: 'd-icon-tcard',
      show: canShowUploadInvoices,
      href: '/pages/upload-invoices',
    },
    {
      key: 'crear-pdv',
      label: 'Crear Punto de Venta',
      icon: 'd-icon-map-marker',
      show: Boolean(participant?.isAConsumerRegistrar),
      href: '/pages/create-pdv',
    },
    {
      key: 'mis-resultados',
      label: 'Mis Resultados',
      icon: 'd-icon-graph',
      show: couldSeeResults && program?.id !== 28 && program?.id !== 39,
      href: '/pages/my-results',
    },
  ];

  return links.filter((l) => l.show).map(({ show, ...link }) => link);
}
